import { useEffect, useRef } from 'react';

export enum KEYS_CODE {
  F5 = 'F5',
  ESC = 'Escape',
  ENTER = 'Enter',
  RIGHT = 'ArrowRight',
  LEFT = 'ArrowLeft',
  UP = 'ArrowUp',
  DOWN = 'ArrowDown',
}

const useKeyDown = (
  callback: (keyCode: KEYS_CODE, event: KeyboardEvent) => void,
  keyCodes: KEYS_CODE[] = [],
  isPassive: boolean = false,
) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const eventKeyCode = event.key as KEYS_CODE;

      if (keyCodes.length > 0 && !keyCodes.includes(eventKeyCode)) {
        return;
      }

      if (!isPassive) {
        event.preventDefault();
      }

      callbackRef.current(eventKeyCode, event);
    };

    const options: AddEventListenerOptions = {
      passive: isPassive,
    };

    document.addEventListener('keydown', handler, options);

    return () => {
      document.removeEventListener('keydown', handler, options);
    };
  }, [isPassive, keyCodes]);
};

export default useKeyDown;
